/**
 * @file paddle 客户案例 案例列表 切换开关
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, {ReactElement, useMemo, useState} from 'react';
import classNames from 'classnames';
import isNil from 'lodash/isNil';

import SwitchButtonItem from './Item';

interface ISwitchButtonProps {
    value?: string | number;
    className?: string;
    onChange?: (key: string | number) => void;
    notEmpty?: boolean;
}

const SwitchButton: React.FC<ISwitchButtonProps> & { Item: typeof SwitchButtonItem } = props => {
    const list = useMemo(() => {
        return React.Children.toArray(props.children).filter((i) => React.isValidElement(i)) as ReactElement[];
    }, [props.children]);

    const [_value, _setValue] = useState<string | number>();
    const value = props.value !== undefined ? props.value : _value;

    const notEmpty = !!props.notEmpty;

    const selectedItem = useMemo(() => {
        return list.find(i => i.props.value === value)
            || list.find(i => (
                isNil(i.props.value)
            ));
    }, [list, value]);

    const selectedIndex = useMemo(() => {
        return list.findIndex(i => i.props.value === value) || 0;
    }, [list, value]);

    const handleOnClick = () => {
        let newIndex = (selectedIndex + 1) % list.length;
        let newValue = list[newIndex].props.value;
        // 如果设置成 notEmpty 模式，在遇到 value === undefined 时就选择下一个元素
        if (notEmpty) {
            for (let i = 0; i < list.length; i++) {
                if (newValue === undefined) {
                    newIndex = (newIndex + 1) % list.length;
                    newValue = list[newIndex].props.value;
                }
                else {
                    break;
                }
            }
        }
        props.onChange ? props.onChange(newValue) : _setValue(newValue);
    };

    return (
        <span
            className={classNames(props.className)}
            onClick={handleOnClick}
        >
            {selectedItem}
        </span>
    );
};
SwitchButton.Item = SwitchButtonItem;
export default SwitchButton;
